jQuery(document).ready(function ($) {
/*
 * Functions
 */
  
  var getScrollDirection = function(prevScroll){
    var scroll = $(window).scrollTop();
    var result;
    if(scroll > prevScroll){
      result = 'up';
    } else {
      result = 'down';
    }
    return result;
  };

  var calcCenter = function(){
    var horizontalCenter = Math.floor(window.innerWidth/2);
    var verticalCenter = Math.floor(window.innerHeight/100*40);
    var result = {
      h: horizontalCenter,
      v: verticalCenter
    };
    return result;
  };

  // Loaded in the middle of page
  var setTargetStates = function(){
    jQuery('.headline-ctn').each(function(index, currentElement){
      var $target = $(currentElement);
      var line = viewport.v;
      var offset = $target.offset().top - $(document).scrollTop();
      if(line > offset){
        $target.addClass('released-up');
      } else if(line < offset && !$target.hasClass('is-fixed')){
        $target.addClass('released-down');
      }
    });
  };

  var resetTargetStates = function(){
    $('.is-fixed').removeClass('is-fixed');
    $('.released-up').removeClass('released-up');
    $('.released-down').removeClass('released-down');
    // alle elemente auf ursprungsposition zurück
    $.each(targetObjArr, function(index, element){
      $(element.element).css('top', targetObjArrOrigin[index]);
    });
  };

  var updateTargetobj = function(){
    $.each(targetObjArr, function(index, element){
      var $target = $(element.element);
      var targetOffset = $target.offset().top;
      var targetHeight = $target.height();
      element.offsetToDocument = targetOffset;
      element.height = targetHeight;
      element.offsetTop = targetOffset - $(document).scrollTop();
      targetObjArrOrigin[index] = $target.offset().top;
    });
  };

  var setTargetObj = function(index, currentElement){
    var $target = $(currentElement);
    $target.attr('data-head-id', index);
    var targetOffset = $target.offset().top;
    var targetHeight = $target.height();
    var $targetObj = {
      id: index,
      element: $target,
      offsetToDocument: targetOffset,
      height: targetHeight,
      offsetTop: targetOffset - $(document).scrollTop(),
    };
    return $targetObj;
  }; 

  var setTargetObjArr = function(targetClass){
    jQuery($(targetClass)).each(function(index, element) {
      targetObjArr.push(setTargetObj(index +1, element));
      targetObjArrOrigin.push($(element).offset().top);
      $(element).css('height', '1');
    });
  }; 

  var fixTargetObj = function(direction, $targetObj){
    // fix: if too fast scroll multiple headlines stick
    $('.is-fixed').removeClass('is-fixed');
    $targetObj.element.removeClass('released-up').removeClass('released-down').addClass('is-fixed');
    stickyObjArr[0] = $targetObj;
    $targetObj.element.css('top', viewport.v);
  };

  var unfixTargetObj = function(direction, oldObj){
    var $oldObj = oldObj;
    if(direction == 'up'){
      $oldObj.element.removeClass('released-down').addClass('released-up');
      $oldObj.element.removeClass('is-fixed');
      $oldObj.element.css('top', targetObjArrOrigin[$oldObj.id - 1]);
    } else if(direction == 'down'){
      $oldObj.element.removeClass('released-up').addClass('released-down');
      $oldObj.element.removeClass('is-fixed');
      $oldObj.element.css('top', targetObjArrOrigin[$oldObj.id - 1]);

    }
    stickyObjArr.pop();
  };

  var resetDirection = function(newDirection){
    var line = viewport.v;
    $.each(targetObjArr, function(index, currentElement){
      var $target = currentElement.element;
      var offset = $target.offset().top - $(document).scrollTop();
      $target.removeClass('released-up').removeClass('released-down');
      if(newDirection == 'up'){
        if(line > offset){
          $target.addClass('released-up');
        } else if(line < offset && !$target.hasClass('is-fixed')){
          $target.addClass('released-down');
        }
      } else if (newDirection == 'down'){
        if(line < offset && !$target.hasClass('is-fixed')){
          $target.addClass('released-down');
        } else if(line > offset){
          $target.addClass('released-up');
        }
      } 
    });
  };

  /*
  * Resize
  */
  $( window ).resize(function(){
    viewport = calcCenter();
    resetTargetStates();
    setTargetStates();
    updateTargetobj();
  });

  /*
  * Init
  */
  var stickyObjArr = [];
  var viewport = calcCenter();
  var targetObjArr = [];
  var targetObjArrOrigin = [];
  setTargetStates();
  setTargetObjArr('.headline-ctn');
  var $firstTargetObj = targetObjArr[0];
  var $lastTargetObj = targetObjArr[targetObjArr.length-1];
  /*
  * Scroll Action
  */

  var prevScroll = $(window).scrollTop();
  var prevScrollDirection = '';

  $( window ).scroll(function() {
    $scrollDirection = getScrollDirection(prevScroll);

    if($scrollDirection == 'up'){
      if(prevScrollDirection == 'down'){
        resetDirection('up');
      }
      $.each(targetObjArr ,function(index, element){
        // offset im obj updaten
        element.offsetTop = element.element.offset().top - $(document).scrollTop();
        element.offsetToDocument = element.element.offset().top;
        if(!element.element.hasClass('is-fixed') && !element.element.hasClass('released-up')){
          // wenn linie erreicht -> fixed
          if(element.offsetTop < viewport.v){
            // ist schon eine Headline sticky? -> lösen
            if(stickyObjArr.length > 0){
              unfixTargetObj($scrollDirection, stickyObjArr[0]);
            } 
            // aktuelles Element -> is-fixed
            fixTargetObj($scrollDirection, element);
          }
        } else if(element.element.hasClass('is-fixed')){
          if(element.offsetToDocument > $('.h-reset-bottom').offset().top){
            unfixTargetObj($scrollDirection, stickyObjArr[0]);
          }
        }
      });
      
    } else if($scrollDirection == 'down'){
      if(prevScrollDirection == 'up'){
        resetDirection('down');
      }
      $.each(targetObjArr ,function(index, element){
        // offset im obj updaten
        element.offsetTop = element.element.offset().top - $(document).scrollTop();
        element.offsetToDocument = element.element.offset().top;
        hResetBottom = $('.h-reset-bottom').offset().top - $(document).scrollTop();
        hResetBottomToDocument = $('.h-reset-bottom').offset().top;
        setInPosition = viewport.v + element.height;

        // letztes Element
        if(element.id == $lastTargetObj.id && element.element.hasClass('released-up')){
          if(hResetBottom > setInPosition){
            fixTargetObj($scrollDirection, element);
          }
        // mittlere Elemente
        } else if(element.element.hasClass('released-up') && !element.element.hasClass('released-down') && !element.element.hasClass('is-fixed')){

          if((targetObjArrOrigin[element.id] - $(document).scrollTop()) > viewport.v ){
            next = element;
            id = parseInt(element.id);
            prev = targetObjArr[id];

            fixTargetObj($scrollDirection, next);
            unfixTargetObj($scrollDirection, prev);
          }
          
        //erstes Element
        } else if(element.id == $firstTargetObj.id){
          if((targetObjArrOrigin[element.id -1] - $(document).scrollTop()) > viewport.v ){
            unfixTargetObj($scrollDirection, element);
          }
        } 
      });

    }
    prevScrollDirection = $scrollDirection;
    prevScroll = $(window).scrollTop();
  });

});